import {
  QSetSimilarityFailedResult,
  QSetSimilarityResult,
  QSetSimilaritySummaryStats,
} from '@exam-management/qset-check-similarity-result';
import { Paper } from '@shared/components';

export default function QSetSimilarityCheckResultsPage() {
  return (
    <Paper
      sx={(theme) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        p: theme.spacing(6),
        m: theme.spacing(6),
        gap: theme.spacing(6),
      })}
    >
      <QSetSimilaritySummaryStats />
      <QSetSimilarityResult />
      <QSetSimilarityFailedResult />
    </Paper>
  );
}
